import React, { Component } from "react";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button.js";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import DispatchService from "../../services/DispatchService";
import { InputText } from "primereact/inputtext";
import tableRequest from "../../models/tableRequest.js";
import { ConfirmationModal } from "../../template/ConfirmationModal";
import MessageComponent from "../../template/Message";
import Loaders from "../../template/Loaders";
import "primereact/resources/themes/nova-light/theme.css"; // or another theme
import "primereact/resources/primereact.min.css"; // Core CSS
import "primeicons/primeicons.css"; // Icons
import $ from "jquery";
import { TreeTable } from "primereact/treetable";

export default class DispatchReturn extends Component {
  constructor(props) {
    super(props);
    this.DispatchService = new DispatchService();
    this.tblResponse = new tableRequest();
    // const nodes = this.transformDataToTreeNodes(flatData);
    this.state = {
      DispatchId: "",
      nodes: [], // Placeholder for your transformed data
      selectedNodeKeys: [], // Placeholder for selected node keys
      emptyMessage: "No data found", // Message when data is empty
      rows: 10, // Number of rows per page
      globalFilter: null,
      visible: false,
      dispatchLoader: true,
      scanLoader: false,
      sortIcon: false,
      sortOrder: "1",
      formError: {
        DispatchId: "",
      },

      data: [
        { diNo: "DI001", cartonId: "CARTON001" },
        { diNo: "DI002", cartonId: "CARTON002" },
        // Add more data as needed
      ],
      selectedRowData: [],
      isDialogVisible: false,
      buttonLabel: "Submit",
      selectedRowData: null,
      checkboxStates: {}, // To store the state of checkboxes
      checkboxValue: false, // For single checkbox toggle
      sales: [],
      selectedStatus: null,
      receive: [],
      getrow: [],
      newrow: [],
      scanItems: [],
      stateover: [],
      loading: true,
      first: 0,
      rows: 5,
      totalRecords: 0,
      globalFilter: null,
      emptyMessage: "No Data found",
    };
    this.actionTemplate = this.actionTemplate.bind(this);
    this.activeTemplate = this.activeTemplate.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.SubmitReceive = this.SubmitReceive.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.hideFunc = this.hideFunc.bind(this);
    this.onPage = this.onPage.bind(this);
    this.searchFilter = this.searchFilter.bind(this);
    this.openDialog = this.openDialog.bind(this);
    this.onSort = this.onSort.bind(this);
    this.transformDataToTreeNodes = this.transformDataToTreeNodes.bind(this);
  }
  //trigger api function on page call
  componentDidMount() {
    setTimeout(() => {
      this.GetDispatchReceive();
    }, 1000);

    $(".p-column-title").on("click", function () {
      $(this)
        .next()
        .removeClass("pi-sort")
        .toggleClass("pi-sort-up")
        .addClass("pi-sort-down");
    });

    console.log("stateover1 :- ", this.state.stateover);
  }

  // PAGE EVENT CALL
  onPage(event) {
    this.setState({
      loading: true,
    });
    //imitate delay of a backend call
    setTimeout(() => {
      debugger;
      this.getLazyLoadingValues(event);
      this.GetDispatchReceive();
      debugger;
    }, 250);
  }

  // set lazy loading values
  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows });
    this.tblResponse.PageSize = 15;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    //this.tblResponse.SortColumn = event.sortField;
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
  }

  // get Dispatch Receive data list from api
  GetDispatchReceive() {
    debugger;
    this.tblResponse.SortColumn = "CreatedDt";
    this.tblResponse.WareHouseId = JSON.parse(
      sessionStorage.getItem("wareHouseId")
    );

    this.DispatchService.GetDispatchReceived(this.tblResponse).then((data) => {
      this.setState({ scanLoader: true });

      const resdata = data.data;
      //if ResponseData not null
      if (
        resdata !== null &&
        resdata.ResponseData !== null &&
        resdata.ResponseData.length > 0
      ) {
        this.datasource = resdata.ResponseData;
        this.setState({
          totalRecords: resdata.ResponseData[0].TotalRows,
          first: this.tblResponse.First - 1,
          sales: this.datasource.slice(
            0,
            this.tblResponse.First - 1 + this.tblResponse.PageSize
          ),
          loading: false,
        });
      }
      //if ResponseData is null
      else {
        this.datasource = null;
        this.setState({
          totalRecords: 0,
          first: 1,
          sales: null,
          loading: false,
        });
      }
    });
  }

  // get Dispatch Receive data list from api

  handleCheckboxChange = (event) => {
    let newArray = [...this.state.receive, event.target.id];
    this.setState({
      receive: newArray,
    });
  };

  // call every change of form and validation part also
  handleChange(event) {
    const { name, value } = event.target;
    let errors = this.state.formError;

    this.setState({ errors, [name]: value });
  }

  // validate form
  validateForm(value, name) {
    let errors = this.state.formError;
    let IsValid = true;
    //to validate each form field with required conditions
    switch (name) {
      case "DispatchId":
        if (value.length < 1) {
          IsValid = false;
          errors.DispatchId = "Please enter DispatchId.";
        } else if (!value.includes("DID")) {
          IsValid = false;
          errors.DispatchId = "Invalid DispatchId.";
        } else errors.DispatchId = "";
        break;
      default:
        break;
    }
    return IsValid;
  }

  // reset form text value
  formReset() {
    this.setState({
      DispatchId: "",
    });
    let errors = this.state.formError;
    Object.entries(errors).map(([key]) => {
      errors[key] = "";
    });
  }

  hideFunc() {
    this.setState({
      visible: false,
      buttonLabel: "Submit",
      formHeading: "Add Number Issue",
    });
    this.formReset();
  }

  // open Dialog
  openDialog() {
    this.setState({ visible: true });
    this.formReset();
  }

  // submit packing
  submitForm(e) {
    debugger;
    //   event.preventDefault();
    let isfrmvalid = true;
    let checkerror = this.state.formError;
    // this.setState({
    //     DispatchId : e.target.value
    // });
    Object.entries(checkerror).map(([key]) => {
      const val = this.state[key];
      let valid = this.validateForm(e.target.value, key); //KREP-59 defect
      //form is not valid
      if (!valid) {
        this.setState({ checkerror: isfrmvalid });
        isfrmvalid = false;
      }
    });

    //form is valid
    if (isfrmvalid) {
      const formData = {
        DispatchId: e.target.value,
      };
      setTimeout(() => {
        this.GetDispatchReceive();
      }, 1000);
    }
  }
 
    mergeNodes = (existingNodes, newNodes) => {
    const existingNodeMap = {};

    // Create a map of existing nodes
    existingNodes.forEach(node => {
        existingNodeMap[node.key] = node;
    });

    // Iterate over new nodes and merge them into existing nodes
    newNodes.forEach(newNode => {
        if (existingNodeMap[newNode.key]) {
            // If the dispatch node already exists, merge children
            existingNodeMap[newNode.key].children.push(...newNode.children);
        } else {
            // If it's a new dispatch node, add it to the existing nodes
            existingNodes.push(newNode);
        }
    });

    return existingNodes;
    };

  // submit packing
  getDispatchCarton(e) {
    debugger;
    if (e.key === "Enter") {
      e.preventDefault();
      let isfrmvalid = true;
      let checkerror = this.state.formError;

      Object.entries(checkerror).map(([key]) => {
        const val = this.state[key];
        let valid = this.validateForm(e.target.value, key); //KREP-59 defect
        //form is not valid
        if (!valid) {
          this.setState({ checkerror: isfrmvalid });
          isfrmvalid = false;
        }
      });
      //form is valid
      if (isfrmvalid) {
        const formData = {
          DispatchId: e.target.value,
        };
        const scanlist = this.state.scanItems;
        // if(this.state.scanItems.includes(formData.DispatchId))
        // {
        //    this.refs.Messchild.showWarn("Already added");
        // }
        console.log('Scan List',scanlist);
        const index = this.state.scanItems.findIndex(
          (item) => item.DispatchId === formData.DispatchId
        );
        //const newArray = [...this.state.scanItems]
        if (index !== -1) {
          // console.log("item exist");
          // newArray.splice(index, 1, item)
          this.refs.Messchild.showWarn("Already added");
        } else {
            this.DispatchService.GetDispatchReturnCarton(formData, scanlist).then(
                (data) => {
                    debugger;
                    const resdata = data.data;
            
                    // If the response data is valid
                    if (
                        resdata.ResponseCode === "200" &&
                        resdata !== null &&
                        resdata.ResponseData !== null &&
                        resdata.ResponseData.length > 0
                    ) {
                        // Transform the fetched data into the required structure
                        const fetchedData = resdata.ResponseData.map((item) => ({
                            DispatchId: item.DispatchId,
                            CartonId: item.CartonId,
                            TotalQty: item.TotalQty,
                            ProductName: item.ProductName,
                        }));
                        
                        // Transform fetched data to tree nodes
                        const newNodes = this.transformDataToTreeNodes(fetchedData);
            
                        // Merge the new nodes with existing nodes
                        const updatedNodes = this.mergeNodes([...this.state.nodes], newNodes);
            
                        // Update the state with the merged nodes and reset the input
                        this.setState({
                            cartonData: fetchedData,
                            nodes: updatedNodes,
                            scanItems: [...this.state.scanItems, ...fetchedData],
                            scanTxt: "",
                            loading: false,
                        });
            
                        // Show success message if present
                        if (resdata.ResponseData[0].ResponseMessage != null) {
                            this.refs.Messchild.showSuccess(resdata.ResponseData[0].ResponseMessage);
                        }
                    } else {
                        // Show warning message if response is invalid
                        this.refs.Messchild.showWarn(resdata.ResponseMessage);
                        this.setState({
                            carton: null,
                            loading: false,
                        });
                    }
                }
            );
            
        }
      }
    }
  }

  // seach table
  searchFilter(e) {
    this.setState({
      loading: true,
    });
    this.tblResponse.SearchValue = e.target.value;
    this.GetDispatchReceive();
  }

  callbackFunction = (childData) => {
    this.setState({ message: childData });
  };

  // add checkbox function
  activeTemplate(rowData, column) {
    return (
      <input
        type="checkbox"
        name={rowData.Id}
        onChange={(e) => {
          this.actionTemplate(e, rowData);
        }}
      />
    );
  }

  // edit form
  actionTemplate(e, rowData) {
    const getid = rowData.Id;
    this.state.newrow.push(getid);
    this.state.getrow.push({
      id: rowData.Id,
    });
  }
  removeScanned() {
    debugger;

    let arr = [this.state.scanItems];
    let arrr1 = arr[0];
    let values = [this.state.stateover];
    let values1 = values[0];
    //arr = arrr1.filter(item => !values1.includes(item));

    for (var obj in values1) {
      debugger;
      arrr1 = arrr1.filter((p) => values1[obj].id == p.Id);
      // arrr1 = arrr1.filter(item => values1.includes(item));
    }
    console.log(arrr1);
    this.setState({
      scanItems: arrr1,
    });
  }

  SubmitReceive() {
    debugger;
    const selectedNodeKeys = this.state.selectedNodeKeys;
    console.log('Selected Nodes ----->',selectedNodeKeys)
    const selectedCartonIds = Object.keys(selectedNodeKeys)
    .filter(key => key.startsWith("SID-")) // Filter keys that start with 'SID-'
    .map(key => ({ Id: key })); // Map the filtered keys to get an array of CartonIds
    console.log('Selected Nodes ----->',selectedCartonIds)
    
    this.DispatchService.DispatchCartonReturn(selectedCartonIds)

      .then((data) => {
        const resdata = data.data;
        if (resdata !== null && resdata.ResponseCode === "200") {
          this.refs.Messchild.showSuccess(resdata.ResponseMessage);

          // Handle UI updates or other actions after successful API call
        } else {
          this.refs.Messchild.showWarn(
            resdata.ResponseMessage || "Failed to process request."
          );
        }
      })
      .catch((error) => {
        console.error("Error while calling API:", error);
        this.refs.Messchild.showError(
          "Failed to process the request. Please try again later."
        );
      });
  }

  // Sort table
  onSort(event) {
    this.setState({
      sortOrder: this.state.sortOrder === 1 ? 2 : 1,
      sortIcon: !this.state.sortIcon,
    });
    const sortField =
      event.sortField == "CreatedDt" ? "CreatedDt" : event.sortField;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC";
    this.GetDispatchReceive();
    const clickData = document.getElementsByClassName(
      "p-sortable-column-icon pi pi-fw pi-sort"
    );
    console.log(event);
  }

  transformDataToTreeNodes = (data) => {
    const groupedData = data.reduce((acc, item) => {
      if (!acc[item.DispatchId]) {
        acc[item.DispatchId] = {
          key: item.DispatchId,
          data: { DispatchId: item.DispatchId },
          children: [],
        };
      }
      acc[item.DispatchId].children.push({
        key: item.CartonId,
        data: {
          DispatchId: item.DispatchId,
          CartonId: item.CartonId,
          TotalQty: item.TotalQty,
          ProductName: item.ProductName,
        },
      });
      return acc;
    }, {});

    return Object.values(groupedData); // Convert object values back to array
  };

//   handleSelectionChange = (e) => {
//     this.setState({ selectedNodeKeys: e.value });
//   };
handleSelectionChange = (e) => {
    debugger;
   // console.log(e.value[0])
    this.setState({ selectedNodeKeys: e.value });
};

  // create html part
  //resolved KREP-134,KREP-114(CR)
  render() {
    let dialogFooter = (
      <Button
        label="Close"
        icon="pi pi-times"
        onClick={() => this.setState({ isDialogVisible: false })}
      />
    );
    let header = (
      <div className="row">
        <div className="col-md-4 text-left">
          <i className="pi pi-search" style={{ margin: "4px 4px 0 0" }}></i>
          {/* <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Global Search1" size="30" /> */}
          <InputText
            type="search"
            onInput={this.searchFilter}
            placeholder="Global Search"
            size="30"
          />
        </div>
      </div>
    );
    //console.log(this.state.selectedStatus);
    let subheader = (
      <div className="row">
        <div className="col-md-8 text-left">
          <form>
            <div className="row">
              <div className="col-md-2 text-left">Scan Item:</div>
              <div className="col-md-6">
                <input
                  type="text"
                  value={this.state.DispatchId}
                  onChange={(e) => {
                    this.handleChange(e);
                  }}
                  onKeyDown={(e) => {
                    this.getDispatchCarton(e);
                  }}
                  className="custom-input"
                  name="DispatchId"
                />
                {this.state.formError.DispatchId !== null ? (
                  <div className="error">{this.state.formError.DispatchId}</div>
                ) : null}
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-4 text-right">
          <i className="pi pi-search" style={{ margin: "4px 4px 0 0" }}></i>
          <InputText
            type="search"
            onInput={(e) => this.setState({ globalFilter: e.target.value })}
            placeholder="Global Search2"
            size="30"
          />
        </div>
      </div>
    );

    return (
      <>
        <MessageComponent ref="Messchild" />
        <ConfirmationModal parentCallback={this.callbackFunction} ref="child" />

        <div className="heading mb-2">
          <h1>Dispatch Received</h1>
        </div>
        <Loaders loader={this.state.scanLoader} classType="small" />
        <DataTable
          responsive={true}
          header={header}
          globalFilter={this.state.globalFilter}
          emptyMessage={this.state.emptyMessage}
          value={this.state.sales}
          sortMode="multiple"
          paginator={true}
          rows={this.state.rows}
          rowsPerPageOptions={[5, 10, 20]}
          totalRecords={this.state.totalRecords}
          lazy={true}
          first={this.state.first}
          onPage={this.onPage}
          onSort={this.onSort}
          className="tblAuto"
        >
          <Column field="DispatchId" header="Dispatch Id" sortable={true} />
          <Column field="CreatedDt" header="Date" sortable={true} />
          <Column
            field="TotalTertiaryCarton"
            header="Total Carton"
            sortable="custom"
          />
          <Column field="Status" header="Status" sortable={true} />
        </DataTable>
        <div className="heading mb-1 mt-3">
          <h1>Carton List</h1>
        </div>
        <Loaders loader={this.state.dispatchLoader} classType="small" />

        <TreeTable
          header={subheader}
          value={this.state.nodes}
          selectionMode="checkbox"
          selectionKeys={this.state.selectedNodeKeys}
          onSelectionChange={this.handleSelectionChange}
          emptyMessage={this.state.emptyMessage}
          rows={this.state.rows}
          rowsPerPageOptions={[5, 10, 20]}
          paginator={true}
          //   paginatorPosition="both"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        >
          <Column field="DispatchId" header="Dispatch Id" expander />
          <Column field="CartonId" header="Carton Id" />
          <Column field="ProductName" header="Product Name" />
          <Column field="TotalQty" header="Quantity" />
        </TreeTable>

        <div className="col-md-12 mt-3 text-center">
          <button
            type="submit"
            onClick={this.SubmitReceive}
            className="btn btn-primary"
          >
            Return
          </button>
        </div>
      </>
    );
  }
}
